import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const currentHarmfulObjects = state => state.models[name].harmfulObjects.results;
export const currentHarmfulObjectsCount = state => state.models[name].harmfulObjects.count;
export const currentHarmfulObject = state => state.models[name].harmfulObject;
export const currentHarmfulObjectDivisions = state => state.models[name].harmfulObjectDivisions;